var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02IconoUnClic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "etapas",
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)",
    fill: "none",
    stroke: "#f0f4f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    strokeDasharray: "1 12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 21.721,
    cy: 21.721,
    r: 21.721,
    fill: "#fdfffc",
    stroke: "#f0f4f9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)",
    fill: "#7821a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_78",
    "data-name": "Grupo 78",
    transform: "translate(-438.443 -100.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    transform: "translate(504.591 146.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412",
    "data-name": "Trazado 412",
    d: "M557.22,161.618v30.354a5.41,5.41,0,0,1-5.41,5.41H511.8a5.975,5.975,0,0,1-5.975-5.974V161.618a4.23,4.23,0,0,1,1.038-2.81,3.359,3.359,0,0,1,2.507-1.164h44.308a3.36,3.36,0,0,1,2.507,1.164A4.228,4.228,0,0,1,557.22,161.618Z",
    transform: "translate(-505.823 -157.644)",
    fill: "#a4c2f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62",
    transform: "translate(504.591 146.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413",
    "data-name": "Trazado 413",
    d: "M553.2,161.618v5.961H505.823v-5.961a4.3,4.3,0,0,1,1.009-2.81,3.228,3.228,0,0,1,2.437-1.164h40.49a3.229,3.229,0,0,1,2.437,1.164A4.3,4.3,0,0,1,553.2,161.618Z",
    transform: "translate(-505.823 -157.644)",
    fill: "#d4e1f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(504.591 154.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M553.2,173.291v27.816a4.447,4.447,0,0,1-.957,2.81,3,3,0,0,1-2.311,1.164H509.091a3,3,0,0,1-2.311-1.164,4.447,4.447,0,0,1-.957-2.81V173.291Z",
    transform: "translate(-505.823 -173.291)",
    fill: "#ebf3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(503.321 144.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M555.99,180.573a1.27,1.27,0,0,1-1.27-1.27V160.248a4.693,4.693,0,0,0-4.688-4.688H510.551a4.693,4.693,0,0,0-4.689,4.688v.441a1.27,1.27,0,0,1-2.54,0v-.441a7.236,7.236,0,0,1,7.228-7.227h39.481a7.236,7.236,0,0,1,7.228,7.227V179.3A1.27,1.27,0,0,1,555.99,180.573Z",
    transform: "translate(-503.323 -153.021)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65",
    "data-name": "Grupo 65",
    transform: "translate(503.319 154.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M504.589,177.038a1.427,1.427,0,0,1-.248-.025,1.242,1.242,0,0,1-.234-.071,1.129,1.129,0,0,1-.219-.117,1.2,1.2,0,0,1-.193-.157,1.278,1.278,0,0,1-.376-.9,1.378,1.378,0,0,1,.026-.249,1.249,1.249,0,0,1,.071-.239,1.716,1.716,0,0,1,.117-.218,1.858,1.858,0,0,1,.162-.193,1.2,1.2,0,0,1,.193-.157,1.127,1.127,0,0,1,.219-.117,1.237,1.237,0,0,1,.234-.071,1.174,1.174,0,0,1,.5,0,1.285,1.285,0,0,1,.239.071,1.312,1.312,0,0,1,.218.117,1.2,1.2,0,0,1,.193.157,1.346,1.346,0,0,1,.157.193,1.3,1.3,0,0,1,.117.218,1.33,1.33,0,0,1,.071.239,1.033,1.033,0,0,1,.025.249,1.272,1.272,0,0,1-.37.9,1.2,1.2,0,0,1-.193.157,1.314,1.314,0,0,1-.218.117,1.29,1.29,0,0,1-.239.071A1.34,1.34,0,0,1,504.589,177.038Z",
    transform: "translate(-503.319 -174.498)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(503.321 159.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M539.766,211.142H510.551a7.236,7.236,0,0,1-7.228-7.228V184.3a1.27,1.27,0,1,1,2.54,0v19.616a4.694,4.694,0,0,0,4.689,4.688h29.214a1.27,1.27,0,1,1,0,2.54Z",
    transform: "translate(-503.323 -183.029)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67",
    transform: "translate(503.59 161.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M523.991,190.422H505.123a1.27,1.27,0,1,1,0-2.54h18.868a1.27,1.27,0,1,1,0,2.54Z",
    transform: "translate(-503.853 -187.882)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "translate(535.85 161.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M587.5,190.422H568.636a1.27,1.27,0,0,1,0-2.54H587.5a1.27,1.27,0,1,1,0,2.54Z",
    transform: "translate(-567.366 -187.882)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69",
    transform: "translate(522.638 157.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_420",
    "data-name": "Trazado 420",
    d: "M552.2,189.844h-6.6a4.25,4.25,0,0,1-4.245-4.245V183.34A4.25,4.25,0,0,1,545.6,179.1h6.6a4.25,4.25,0,0,1,4.245,4.245V185.6A4.25,4.25,0,0,1,552.2,189.844Zm-6.6-8.21a1.707,1.707,0,0,0-1.706,1.706V185.6A1.707,1.707,0,0,0,545.6,187.3h6.6A1.707,1.707,0,0,0,553.9,185.6V183.34a1.707,1.707,0,0,0-1.706-1.706Z",
    transform: "translate(-541.353 -179.095)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_70",
    "data-name": "Grupo 70",
    transform: "translate(509.715 172.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421",
    "data-name": "Trazado 421",
    d: "M523.336,217.428h-6.154a1.27,1.27,0,0,1-1.27-1.27v-6.035a1.27,1.27,0,1,1,2.54,0v4.765h4.885a1.27,1.27,0,1,1,0,2.54Z",
    transform: "translate(-515.912 -208.853)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    transform: "translate(517.438 134.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_422",
    "data-name": "Trazado 422",
    d: "M532.386,146.577a1.27,1.27,0,0,1-1.164-1.777l3.415-7.85a3.634,3.634,0,0,1,3.334-2.186h11.7a3.586,3.586,0,0,1,3.181,1.918l4.231,8.032a1.27,1.27,0,0,1-2.247,1.184l-4.231-8.032a1.052,1.052,0,0,0-.934-.563h-11.7a1.1,1.1,0,0,0-1.005.659l-3.416,7.851A1.27,1.27,0,0,1,532.386,146.577Z",
    transform: "translate(-531.116 -134.765)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72",
    transform: "translate(522.833 139.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423",
    "data-name": "Trazado 423",
    d: "M543.007,151.32a1.27,1.27,0,0,1-1.135-1.838l1.852-3.705a2.58,2.58,0,0,1,2.313-1.373h6.345a2.569,2.569,0,0,1,2.2,1.2l2.3,3.792a1.27,1.27,0,0,1-2.172,1.315l-2.275-3.757a.17.17,0,0,0-.05-.007h-6.345a.174.174,0,0,0-.061.01l-1.832,3.664A1.27,1.27,0,0,1,543.007,151.32Z",
    transform: "translate(-541.738 -144.404)",
    fill: "#264ecc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73",
    transform: "translate(540.953 170.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_424",
    "data-name": "Trazado 424",
    d: "M595.366,211.842l-20.972-7.084a1.122,1.122,0,0,0-1.276,1.146l7.053,21.381s.665.758,1.2.109,3.489-6.036,3.489-6.036l9.2,9.233a1.437,1.437,0,0,0,1.8.324l3.246-3.4a1.636,1.636,0,0,0,0-1.623l-9.276-9.292,5.668-3.807A.537.537,0,0,0,595.366,211.842Z",
    transform: "translate(-573.118 -204.755)",
    fill: "#f1eaf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_76",
    "data-name": "Grupo 76",
    transform: "translate(540.953 170.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(5.933 17.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M590.343,251.426s-.483.88-1.093,1.971l1.12,3.394s.665.757,1.2.109c.229-.278.9-1.423,1.594-2.642Z",
    transform: "translate(-589.25 -251.426)",
    fill: "#efd2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_75",
    "data-name": "Grupo 75",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M599.1,225.9l-9.276-9.292,5.668-3.807a.537.537,0,0,0-.128-.955l-20.972-7.084a1.122,1.122,0,0,0-1.276,1.146l.214.65L590.65,212.4a.537.537,0,0,1,.128.955l-5.668,3.807,9.276,9.293a1.635,1.635,0,0,1,0,1.622L593,229.529l1.059,1.062a1.437,1.437,0,0,0,1.8.324l3.246-3.4A1.636,1.636,0,0,0,599.1,225.9Z",
    transform: "translate(-573.118 -204.755)",
    fill: "#efd2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(540.031 170.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M593.574,230.452a2.461,2.461,0,0,1-1.773-.817l-8.312-8.341c-.936,1.689-2.556,4.575-2.993,5.1a1.559,1.559,0,0,1-1.182.6h-.023a2,2,0,0,1-1.4-.684l-.124-.141-.058-.178-7.1-21.529,0-.156a2.022,2.022,0,0,1,.655-1.541,2.232,2.232,0,0,1,1.636-.5l.1.011,21.07,7.116a1.457,1.457,0,0,1,.346,2.59l-4.742,3.184,8.572,8.6a2.488,2.488,0,0,1,.067,2.623l-.057.1-3.421,3.581-.119.067A2.321,2.321,0,0,1,593.574,230.452Zm-10.515-12.195,10.123,10.164a.488.488,0,0,0,.54.157l3.027-3.169a.765.765,0,0,0,.052-.51l-10-10.018,5.953-4-20.1-6.789a.373.373,0,0,0-.164.049.18.18,0,0,0-.023.069l6.828,20.7c.571-.9,1.957-3.351,3.177-5.576Zm10.427-7.127h0Z",
    transform: "translate(-570.61 -202.253)",
    fill: "#7821a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02IconoUnClic);
export default __webpack_public_path__ + "static/media/02-icono-un-clic.d8209dccd237cd3dbb08963a114e6114.svg";
export { ForwardRef as ReactComponent };